























































import { Mixins, Component, Vue } from 'vue-property-decorator';
import InitLocation from 'src/mixin/initLocation';
import Config from 'util/config';

@Component
export default class CustomizedSelect extends Mixins(InitLocation) {
  hasGarden = false;

  visible = false;

  customized = {
    id: '',
    name: '全国',
    province: '',
    city: '',
    downtown: '',
  }

  hotCityList = [
    { parentId: '', id: '', name: '全国' },
    { parentId: '110000', id: '110100', name: '北京' },
    { parentId: '120000', id: '120100', name: '天津' },
    { parentId: '310000', id: '310100', name: '上海' },
    { parentId: '440000', id: '440100', name: '广州' },
    { parentId: '440000', id: '440300', name: '深圳' },
    { parentId: '510000', id: '510100', name: '成都' },
    { parentId: '500000', id: '500100', name: '重庆' },
  ]

  selectHotCity(id: string, name: string, parentId: string) {
    this.province = '';
    this.city = '';
    this.downtown = '';
    this.cityList = [];
    this.downtownList = [];
    if (id) {
      this.province = parentId;
      this.city = id;
      this.initLocation();
    }
  }

  confirm() {
    if (this.downtown) {
      const sItem = this.downtownList.find(item => item.id === this.downtown);
      if (sItem) {
        this.customized.name = sItem.name;
      }
      this.customized.id = this.downtown;
    } else if (this.city) {
      const sItem = this.cityList.find(item => item.id === this.city);
      if (sItem) {
        this.customized.name = sItem.name;
      }
      this.customized.id = this.city;
    } else if (this.province) {
      const sItem = this.provinceList.find(item => item.id === this.province);
      if (sItem) {
        this.customized.name = sItem.name;
      }
      this.customized.id = this.province;
    } else {
      this.customized.name = '全国';
      this.customized.id = '';
    }
    Vue.ls.set('customized', this.customized, Config.ACCOUNT_EXPIRE);
    this.$emit('change', this.customized.name);
    this.visible = false;
  }

  mounted() {
    const customized = Vue.ls.get('customized');
    if (customized) this.customized = customized;
    this.initLocation();
  }

  get province() {
    return this.customized.province;
  }

  set province(val) {
    this.customized.province = val;
  }

  get city() {
    return this.customized.city;
  }

  set city(val) {
    this.customized.city = val;
  }

  get downtown() {
    return this.customized.downtown;
  }

  set downtown(val) {
    this.customized.downtown = val;
  }
}
